
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { useFailedLoginAttemptsModule } from '@/modules/failed-login-attempts'
import { FailedLoginAttemptsRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'view-failed-login-attempts-show',
    async setup () {
        const $q = useQuasar()
        const route = useRoute()
        const { getFailedLoginAttempt, deleteFailedLoginAttempt } = useFailedLoginAttemptsModule()
        const failedLoginAttempt = await getFailedLoginAttempt(route.params.id as string)

        async function onDeleteFailedLoginAttempt () {
            await deleteFailedLoginAttempt(failedLoginAttempt.id)
            $q.notify({
                color: 'positive',
                message: 'Failed login attempt has been deleted'
            })
        }

        return {
            failedLoginAttempt,
            onDeleteFailedLoginAttempt,
            FailedLoginAttemptsRouteNames,
            route
        }
    }
})
